import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card-no-shadow bg-white rounded-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-extrabold" }, "Trayek", -1)
const _hoisted_3 = { class: "item-check" }
const _hoisted_4 = ["for"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-extrabold" }, "Kelas", -1)
const _hoisted_6 = { class: "item-check" }
const _hoisted_7 = ["for"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-extrabold" }, "Tol/Non Tol", -1)
const _hoisted_9 = { class: "item-check" }
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "inline-flex gap-7 items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "Trayek", -1)
const _hoisted_13 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_14 = ["for"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "my-no-more" }, null, -1)

import {
  onMounted,
  ref,
  computed,
  getCurrentInstance,
  reactive,
  watch
} from 'vue'
import { useStore } from 'vuex'
import Checkbox from 'primevue/checkbox'
import Dialog from 'primevue/dialog'
import ProgressSpinner from 'primevue/progressspinner'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import AccordionDefault from '@/views/components/accordion/Default.vue'
import apiUseCase from '@/usecase/apiUseCase'
import { ITrayek } from '@/utils/interfaces/iTrayek'
import { MSClass } from '@/utils/interfaces/iMsClass'
import { VueEternalLoading, LoadAction } from '@ts-pro/vue-eternal-loading'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import { debounce } from 'lodash'
import { IFilter } from '@/store/modules/plotting/model'

type TTrayekFilter = ITrayek & { IsCheck: boolean }
type TClassFilter = MSClass & { IsCheck: boolean }
type TTolFilter = IFilter & { IsCheck: boolean }


export default /*#__PURE__*/_defineComponent({
  __name: 'LeftFilter',
  props: {
  isRoster: {
    type: Boolean,
    default: false
  },
},
  setup(__props) {

const props = __props

const module = 'plotting'
const endpointTrayek = '/management/v1/Trayek'
const endpointClass = '/management/v1/MsClass'



const app = getCurrentInstance()
const {
  $icon
} = app!.appContext.config.globalProperties
const store = useStore()
const classList = ref<TClassFilter[]>([])
const trayekList = ref<TTrayekFilter[]>([])
const optionTol = ref<TTolFilter[]>([{
  label: 'Tol',
  value: 'true',
  IsCheck: false
},
{
  label: 'Non Tol',
  value: 'false',
  IsCheck: false
}])
const trayekListFront = ref<TTrayekFilter[]>([])
const listFilterTrayek = computed<IFilter[]>(() => store.getters[`${module}/filterTrayek`])
const listFilterClass = computed<IFilter[]>(() => store.getters[`${module}/filterClass`])
const listFilterTol = computed<IFilter[]>(() => store.getters[`${module}/filterTol`])
const showDialog = ref(false)
const inputSearch = ref('')
const isRoster = computed(() => props.isRoster)

const getAllClass = () => {
  apiUseCase.get(`${endpointClass}${returnUrlPrams({
    custom: [['activeOnly', '=', 'true']]
  })}`).then((response) => {
    const result = response.result as MSClass[]
    classList.value = result.map((v) => ({
      ...v,
      IsCheck: false
    }))
  })
}

const onCheckTrayek = (isCheck: boolean, row: TTrayekFilter) => {
  row.IsCheck = isCheck
  store.dispatch(`${module}/setFilterTrayek`, {
    label: row.Name,
    value: row.Id
  })
}

const onCheckClass = (isCheck: boolean, row: TClassFilter) => {
  row.IsCheck = isCheck
  store.dispatch(`${module}/setFilterClass`, {
    label: row.Name,
    value: row.Id
  })
}

const onCheckTol = (isCheck: boolean, row: TTolFilter) => {
  row.IsCheck = isCheck
  store.dispatch(`${module}/setFilterTol`, {
    label: row.label,
    value: row.value
  })
}

const paginate = reactive({
  pageSize: 12,
  pageNumber: 1,
  totalRecords: 0,
})

const tempLengthOfList = ref(0)
const getAllTrayek = async (reset = false) => {
  const {
    result,
    error
  } = await apiUseCase.get(`${endpointTrayek}${returnUrlPrams({
    pageNumber: paginate.pageNumber,
    pageSize: paginate.pageSize,
    search: inputSearch.value,
    filterField: ['name'],
    custom: [['activeOnly', '=', 'true'], ['trayekTypeId', '=', isRoster.value ? '971ab31f-207d-4ad5-8670-d9fcb9185475' : '8e072a19-599c-45f0-a337-08dbd378cce6']]
  })}`)
  if (!error) {
    if (reset) {
      trayekList.value = []
    }
    const dataResult = result as ITrayek[]
    tempLengthOfList.value = dataResult.length
    trayekList.value = [...trayekList.value, ...dataResult.map((v) => ({
      ...v,
      IsCheck: false
    }))]
    paginate.pageNumber += 1
  }
}

const isInitial = ref(false)
/** Fungsi emit dri child FormAssigCourier */
const reloadData = async () => {
  // store.dispatch('showLoading')
  paginate.pageNumber = 0
  await getAllTrayek(true)
  isInitial.value = true
  // store.dispatch('hideLoading')
}

/** Menggunakan load data untuk plugin pagination */
const loadData = async ({ loaded, noMore }: LoadAction) => {
  getAllTrayek(isInitial.value).then(() => {
    if (tempLengthOfList.value < paginate.pageSize) {
      /** menggunakan fungsi unutuk mereset state data kosong type dri interface plugin vue-eternal-loading */
      noMore()
    } else {
      /** menggunakan fungsi unutuk load state type dri interface plugin vue-eternal-loading */
      loaded()
    }
  })
}

const onSearch = () => {
  reloadData()
}

watch(inputSearch, debounce(onSearch, 500))

const getTrayekListFront = async () => {
  const {
    result,
    error
  } = await apiUseCase.get(`${endpointTrayek}${returnUrlPrams({
    pageSize: 5,
    custom: [['activeOnly', '=', 'true'], ['trayekTypeId', '=', isRoster.value ? '971ab31f-207d-4ad5-8670-d9fcb9185475' : '8e072a19-599c-45f0-a337-08dbd378cce6']]
  })}`)
  if (!error) {
    const dataResult = result as ITrayek[]
    trayekListFront.value = dataResult.map((v) => ({
      ...v,
      IsCheck: false
    }))
  }
}

onMounted(() => {
  getTrayekListFront()
  getAllClass()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(AccordionDefault, { class: "mb-5 left-filter-accordion mt-2" }, {
        header: _withCtx(() => [
          _hoisted_2
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trayekListFront.value, (data, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "mb-2 flex items-center"
              }, [
                _createVNode(_unref(Checkbox), {
                  modelValue: Boolean(_unref(listFilterTrayek).find((v) => v.value === data.Id)),
                  "onUpdate:modelValue": (v) => onCheckTrayek(v, data),
                  inputId: `trayek-${idx}`,
                  binary: true
                }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                _createElementVNode("label", {
                  for: `trayek-${idx}`,
                  class: "ml-2"
                }, _toDisplayString(data.Name), 9, _hoisted_4)
              ]))
            }), 128)),
            _createElementVNode("p", {
              class: "text-sm text-primary mt-2 cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {showDialog.value = true; inputSearch.value = ''})
            }, "Lihat Selengkapnya")
          ])
        ]),
        _: 1
      }),
      _createVNode(AccordionDefault, { class: "mb-5 left-filter-accordion" }, {
        header: _withCtx(() => [
          _hoisted_5
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classList.value, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "mb-1"
              }, [
                _createVNode(_unref(Checkbox), {
                  modelValue: Boolean(_unref(listFilterClass).find((v) => v.value === row.Id)),
                  "onUpdate:modelValue": (v) => onCheckClass(v, row),
                  inputId: `class-${idx}`,
                  binary: true
                }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                _createElementVNode("label", {
                  for: `class-${idx}`,
                  class: "ml-2"
                }, _toDisplayString(row.Name), 9, _hoisted_7)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(AccordionDefault, { class: "mb-5 left-filter-accordion" }, {
        header: _withCtx(() => [
          _hoisted_8
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionTol.value, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "mb-1"
              }, [
                _createVNode(_unref(Checkbox), {
                  modelValue: Boolean(_unref(listFilterTol).find((v) => v.value === row.value)),
                  "onUpdate:modelValue": (v) => onCheckTol(v, row),
                  inputId: `class-${idx}`,
                  binary: true
                }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
                _createElementVNode("label", {
                  for: `class-${idx}`,
                  class: "ml-2"
                }, _toDisplayString(row.label), 9, _hoisted_10)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(Dialog), {
      visible: showDialog.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showDialog).value = $event)),
      header: "Trayek",
      style: { width: '50rem' },
      breakpoints: { '1199px': '75vw', '575px': '90vw' },
      position: "left",
      modal: true,
      draggable: false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(InputIconRight, {
            class: "input-search-header-custom",
            placeholder: "Cari Trayek...",
            modelValue: inputSearch.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputSearch).value = $event)),
            canClick: true,
            icon: _unref($icon).svg.searchEva
          }, null, 8, ["modelValue", "icon"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trayekList.value, (data, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "mb-2 flex items-center"
            }, [
              _createVNode(_unref(Checkbox), {
                modelValue: Boolean(_unref(listFilterTrayek).find((v) => v.value === data.Id)),
                "onUpdate:modelValue": (v) => onCheckTrayek(v, data),
                inputId: `trayek-${idx}`,
                binary: true
              }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId"]),
              _createElementVNode("label", {
                for: `trayek-${idx}`,
                class: "ml-2"
              }, _toDisplayString(data.Name), 9, _hoisted_14)
            ]))
          }), 128))
        ]),
        _createVNode(_unref(VueEternalLoading), {
          load: loadData,
          "is-initial": isInitial.value,
          "onUpdate:is-initial": _cache[2] || (_cache[2] = ($event: any) => ((isInitial).value = $event)),
          class: "flex justify-center"
        }, {
          loading: _withCtx(() => [
            _createVNode(_unref(ProgressSpinner), {
              class: "h-8",
              strokeWidth: "5"
            })
          ]),
          "no-more": _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["is-initial"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})